module.exports = __webpack_public_path__ + "static/media/geo.8a2703dd.jpg";